var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pd-t140 main theme-style-01"},[_c('transition',{attrs:{"enter-active-class":"bounceInRight"}},[_c('router-view',{staticClass:"animated"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }